const stories = [

    // LESSON 1
    // Introductions & Personal Information

    {
        story:
            'Привіт, мене звати Лєна. \nЯ з України. \nЯ приїхала до Великої Британії в лютому 2023р. \nЯ живу в Стратфорді. \nПрацюю в кавярні Coffee #1 в центрі міста. \nЗараз я вивчаю англійську мову. \nМені подобається знайомитися з новими людьми. \nУ вільний час я люблю читати і гуляти вздовж каналу. \nЯ рада бути тут!',
        translation:
            'Hello, my name is Lena. \nI am from Ukraine.\nI arrived in the UK in February 2023. \nI live in Stratford-upon-Avon. \nI work in Coffee #1 in the the center of the town. \nI am learning English now. \nI like meeting new people. \nIn my free time, I enjoy reading, walking along the canal. \nI am happy to be here!'
    },

    // LESSON 2
    // Daily Routines

    {
        story:
            'Я прокидаюся о шостій годині ранку. \nЯ роблю зарядку і приймаю душ. \nПотім я готую сніданок і п’ю каву. \nЯ йду на роботу або працюю вдома. \nВдень я зустрічаюся з колегами і працюю над проектами. \nОбідаю приблизно о дванадцятій годині. \nПісля роботи я ходжу в спортзал або гуляю на вулиці. \nВечеряю з родиною або друзями. \nВечорами я дивлюся новини або читаю книгу. \nЛягаю спати близько десятої години вечора.',
        translation:
            'I wake up at six o’clock in the morning. \nI do exercises and take a shower. \nThen I prepare breakfast and drink coffee. \nI go to work or work from home. \nDuring the day, I meet with colleagues and work on projects. \nI have lunch around twelve o’clock. \nAfter work, I go to the gym or take a walk outside. \nI have dinner with my family or friends. \nIn the evenings, I watch the news or read a book. \nI go to bed around ten o’clock at night.'
    },


    // LESSON 3
    // Hobbies & Free Time

    {
        story:
            'У вільний час я люблю малювати. \nЯ також люблю слухати музику. \nІноді я граю на гітарі. \nУ вихідні я часто ходжу на прогулянки. \nМені подобається кататися на велосипеді. \nЩе я люблю читати книжки. \nМій улюблений жанр – детективи. \nЯ часто читаю перед сном. \nМені подобається бути активною. \nХобі допомагають мені розслабитися.',
        translation:
            'In my free time, I like to draw. \nI also enjoy listening to music. \nSometimes I play the guitar. \nOn weekends, I often go for walks. \nI like riding my bike. \nI also love reading books. \nMy favorite genre is detective stories. \nI often read before bed. \nI like to stay active. \nHobbies help me relax.'
    },

    // LESSON 4
    // Travel & Holidays

    {
        story:
            'Минулого літа я була в Італії. \nЯ відвідала Рим і Венецію. \nМені дуже сподобалась архітектура. \nЯ їла багато піци і морозива. \nПогода була сонячна і тепла. \nЯ зробила багато фотографій. \nЛюди були дуже привітні. \nМоя мрія — поїхати до Японії. \nЯ хочу побачити гору Фудзі. \nПодорожі роблять мене щасливою.',
        translation:
            'Last summer, I went to Italy. \nI visited Rome and Venice. \nI really liked the architecture. \nI ate a lot of pizza and ice cream. \nThe weather was sunny and warm. \nI took many photos. \nThe people were very friendly. \nMy dream is to go to Japan. \nI want to see Mount Fuji. \nTraveling makes me happy.'
    },

    // LESSON 5
    // Food & Cooking

    {
        story:
            'Я люблю готувати вдома. \nМоя улюблена страва — борщ. \nЯ готую його з буряком і капустою. \nТакож я люблю варити супи. \nЩе я часто печу пироги. \nЯ люблю готувати для родини. \nМи вечеряємо разом щовечора. \nНа сніданок я їм вівсянку. \nЯ намагаюся їсти здорову їжу. \nГотування — моє улюблене заняття.',
        translation:
            'I like cooking at home. \nMy favorite dish is borscht. \nI cook it with beetroot and cabbage. \nI also enjoy making soups. \nI often bake pies too. \nI love cooking for my family. \nWe have dinner together every evening. \nFor breakfast, I eat oatmeal. \nI try to eat healthy food. \nCooking is my favorite activity.'
    },

    // LESSON 6
    // Family & Friends

    {
        story:
            'У мене маленька родина. \nЯ живу з чоловіком і донькою. \nМоя донька ходить до школи. \nМи любимо проводити час разом. \nУ вихідні ми їздимо в парк або до бабусі. \nМоя найкраща подруга живе поруч. \nМи часто п’ємо чай і розмовляємо. \nЯ довіряю їй і ціную нашу дружбу. \nМоя родина і друзі дуже важливі для мене. \nВони завжди мене підтримують.',
        translation:
            'I have a small family. \nI live with my husband and daughter. \nMy daughter goes to school. \nWe love spending time together. \nOn weekends, we go to the park or visit grandma. \nMy best friend lives nearby. \nWe often drink tea and talk. \nI trust her and value our friendship. \nMy family and friends are very important to me. \nThey always support me.'
    },


    // LESSON 7
    // School & Education

    {
        story:
            'Я зараз вивчаю англійську мову. \nЯ ходжу на курси тричі на тиждень. \nУ нашій групі десять студентів. \nНаш учитель дуже добрий. \nМи читаємо, пишемо і говоримо англійською. \nІноді ми дивимося відео. \nЯ стараюся робити домашнє завдання. \nМені подобається вчитися. \nЯ хочу говорити англійською вільно. \nОсвіта — це важливо для мого майбутнього.',
        translation:
            'I am learning English now. \nI go to classes three times a week. \nThere are ten students in our group. \nOur teacher is very kind. \nWe read, write, and speak in English. \nSometimes we watch videos. \nI try to do my homework. \nI enjoy learning. \nI want to speak English fluently. \nEducation is important for my future.'
    },


    // LESSON 8
    // Work & Careers

{
    story:
        'Я працюю в магазині одягу. \nМоя робота починається о дев’ятій ранку. \nЯ допомагаю клієнтам і складаю товари. \nІноді я працюю на касі. \nЯ маю гарних колег. \nМи часто працюємо в команді. \nМені подобається моя робота. \nЯ люблю спілкуватися з людьми. \nЯ хочу рости в кар’єрі. \nРобота дає мені досвід і гроші.',
    translation:
        'I work in a clothing shop. \nMy job starts at nine in the morning. \nI help customers and arrange products. \nSometimes I work at the till. \nI have nice coworkers. \nWe often work as a team. \nI like my job. \nI enjoy talking to people. \nI want to grow in my career. \nWork gives me experience and money.'
},

    // LESSON 9
    // Shopping & Money

    {
    story:
        'Я люблю ходити по магазинах. \nЯ часто купую продукти в супермаркеті. \nЯ завжди складаю список. \nЦе допомагає не забути нічого. \nІноді я купую одяг у торговому центрі. \nЯ стараюся не витрачати багато грошей. \nЯ використовую знижки і акції. \nЯ також купую дещо онлайн. \nГроші важливо витрачати з розумом. \nЯ вчуся планувати свій бюджет.',
    translation:
        'I like going shopping. \nI often buy groceries at the supermarket. \nI always make a list. \nIt helps me not forget anything. \nSometimes I buy clothes at the mall. \nI try not to spend too much money. \nI use discounts and special offers. \nI also buy some things online. \nIt is important to spend money wisely. \nI am learning to plan my budget.'
},

    // LESSON 10
    // Technology & Social Media

    {
    story:
        'Я часто користуюся телефоном. \nЯ пишу повідомлення і телефоную друзям. \nЯ дивлюся відео на YouTube. \nЯ користуюсь Інтернетом щодня. \nУ мене є акаунт у Facebook і Instagram. \nЯ люблю ділитися фотографіями. \nСоціальні мережі допомагають мені бути на зв’язку. \nАле я стараюся не сидіти в телефоні весь день. \nІнколи я роблю перерву від технологій. \nБаланс дуже важливий.',
    translation:
        'I often use my phone. \nI text and call my friends. \nI watch videos on YouTube. \nI use the Internet every day. \nI have Facebook and Instagram accounts. \nI like sharing photos. \nSocial media helps me stay connected. \nBut I try not to be on my phone all day. \nSometimes I take a break from technology. \nBalance is very important.'
},

    // LESSON 11
    // Movies & TV Shows

    {
    story:
        'Я люблю дивитися фільми. \nМій улюблений жанр — комедії. \nІноді я дивлюся серіали на Netflix. \nЯ зазвичай дивлюсь ввечері. \nЯ дивлюсь фільми з родиною. \nМи готуємо попкорн і насолоджуємось часом разом. \nМій улюблений фільм — «Форрест Гамп». \nЦе зворушлива історія. \nЯ люблю сміятись і плакати під час фільмів. \nКіно — це гарний відпочинок.',
    translation:
        'I love watching movies. \nMy favorite genre is comedy. \nSometimes I watch series on Netflix. \nI usually watch in the evening. \nI watch movies with my family. \nWe make popcorn and enjoy time together. \nMy favorite movie is “Forrest Gump.” \nIt is a touching story. \nI like to laugh and cry during movies. \nMovies are a nice way to relax.'
},

    // LESSON 12
    // Music & Entertainment

    {
    story:
        'Я слухаю музику щодня. \nМій улюблений стиль — поп. \nЯ люблю співати вдома. \nІноді я слухаю музику в навушниках. \nМузика робить мене щасливою. \nЯ також люблю танцювати. \nМій улюблений співак — Ед Ширан. \nЯ слухаю радіо по дорозі на роботу. \nМузика допомагає мені розслабитися. \nЦе велика частина мого життя.',
    translation:
        'I listen to music every day. \nMy favorite style is pop. \nI love singing at home. \nSometimes I listen to music with headphones. \nMusic makes me happy. \nI also love dancing. \nMy favorite singer is Ed Sheeran. \nI listen to the radio on the way to work. \nMusic helps me relax. \nIt is a big part of my life.'
},

    // LESSON 13
    // Sports & Exercise

    {
    story:
        'Я займаюся спортом два рази на тиждень. \nЯ ходжу на фітнес. \nЦе допомагає мені залишатися здоровою. \nЯ також люблю плавати. \nВлітку я граю в волейбол на вулиці. \nІноді я бігаю в парку. \nЯ люблю бути активною. \nСпорт — це енергія і сила. \nВін допомагає зняти стрес. \nРух — це життя.',
    translation:
        'I do sports twice a week. \nI go to fitness classes. \nIt helps me stay healthy. \nI also like swimming. \nIn summer, I play volleyball outside. \nSometimes I run in the park. \nI like being active. \nSport is energy and strength. \nIt helps me relieve stress. \nMovement is life.'
},

    // LESSON 14
    // News & Current Events

    {
    story:
        'Щоранку я дивлюсь новини. \nЯ читаю новини в Інтернеті. \nЯ хочу знати, що відбувається у світі. \nЯ особливо цікавлюся подіями в Україні. \nТакож читаю про погоду і економіку. \nІноді новини бувають сумні. \nАле я думаю, що важливо бути поінформованим. \nЯ обговорюю новини з друзями. \nМи ділимось думками. \nЦе допомагає краще розуміти світ.',
    translation:
        'Every morning I watch the news. \nI read news online. \nI want to know what is happening in the world. \nI am especially interested in events in Ukraine. \nI also read about the weather and economy. \nSometimes the news is sad. \nBut I think it’s important to be informed. \nI discuss the news with my friends. \nWe share our opinions. \nIt helps me understand the world better.'
},

    // LESSON 15
    // Dreams & Future Plans

    {
    story:
        'Я мрію стати медсестрою. \nЯ хочу допомагати людям. \nЗараз я вивчаю англійську. \nУ майбутньому я хочу піти в коледж. \nМоя мета — знайти добру роботу. \nЯ також мрію подорожувати. \nЯ хочу побачити Париж і Нью-Йорк. \nМрії дають мені мотивацію. \nЯ знаю, що все можливо. \nЯ працюю для свого майбутнього.',
    translation:
        'I dream of becoming a nurse. \nI want to help people. \nNow I am learning English. \nIn the future, I want to go to college. \nMy goal is to find a good job. \nI also dream of traveling. \nI want to see Paris and New York. \nDreams give me motivation. \nI know everything is possible. \nI work for my future.'
},

    // LESSON 16
    // Cultural Differences

    {
    story:
        'Коли я приїхала до Великої Британії, все було нове. \nЛюди розмовляють англійською. \nЇжа тут інша, ніж в Україні. \nТут усі дуже ввічливі. \nВсі стоять у черзі. \nУ Британії багато правил дорожнього руху. \nМені подобається ця культура. \nЯ вчуся новому щодня. \nІноді мені важко, але я стараюсь. \nКультурні відмінності роблять світ цікавішим.',
    translation:
        'When I came to the UK, everything was new. \nPeople speak English. \nThe food is different from Ukraine. \nEveryone is very polite. \nPeople stand in line. \nThere are many traffic rules in the UK. \nI like this culture. \nI learn something new every day. \nSometimes it is hard, but I try. \nCultural differences make the world more interesting.'
},

    // LESSON 17
    // Weather & Seasons

    {
    story:
        'Сьогодні сонячно і тепло. \nЯ люблю весну. \nКвіти починають цвісти. \nВлітку я ходжу на пікніки. \nВосени листя стає жовтим. \nВзимку я ношу теплий одяг. \nЯ люблю всі пори року. \nАле моя улюблена — весна. \nПогода дуже впливає на мій настрій. \nСонце робить мене щасливою.',
    translation:
        'Today is sunny and warm. \nI love spring. \nThe flowers start to bloom. \nIn summer, I go on picnics. \nIn autumn, the leaves turn yellow. \nIn winter, I wear warm clothes. \nI love all seasons. \nBut my favorite is spring. \nThe weather really affects my mood. \nThe sun makes me happy.'
},

    // LESSON 18
    // Health & Wellness
{
    story:
        'Я стараюся піклуватися про своє здоров’я. \nЯ їм овочі і фрукти щодня. \nЯ п’ю багато води. \nЯ стараюся спати вісім годин. \nТакож я ходжу на прогулянки. \nКоли я хворію, я йду до лікаря. \nЯ мию руки перед їжею. \nЗдоров’я — це найважливіше. \nЯ також стараюся думати позитивно. \nТіло і розум мають бути в гармонії.',
    translation:
        'I try to take care of my health. \nI eat vegetables and fruits every day. \nI drink a lot of water. \nI try to sleep for eight hours. \nI also go for walks. \nWhen I am sick, I see a doctor. \nI wash my hands before eating. \nHealth is the most important thing. \nI also try to think positively. \nThe body and mind should be in harmony.'
},

    // LESSON 19
    // Personal Experiences & Stories

    {
    story:
        'Одного разу я втратила свій гаманець. \nЦе сталося в супермаркеті. \nЯ була дуже схвильована. \nЯ повернулася назад і спитала на касі. \nДобра людина його знайшла і віддала. \nЯ була дуже вдячна. \nЦей день я пам’ятаю досі. \nІнколи стаються добрі чудеса. \nЦя ситуація навчила мене бути уважною. \nІ вірити в добрих людей.',
    translation:
        'One day I lost my wallet. \nIt happened in the supermarket. \nI was very upset. \nI went back and asked at the counter. \nA kind person found it and returned it. \nI was very thankful. \nI still remember that day. \nSometimes good things happen. \nThis situation taught me to be careful. \nAnd to believe in kind people.'
},

    // LESSON 20
    // If You Could...

    {
    story:
        'Якби я могла, я б поїхала в Ісландію. \nЯ мрію побачити північне сяйво. \nЯ також хочу поплавати в гарячому джерелі. \nЯкби в мене було більше грошей, я б більше подорожувала. \nЯ б вивчала нові мови. \nЯ б відкрила маленьке кафе. \nЯ б жила біля моря. \nМрії роблять життя цікавішим. \nУсе можливо, якщо старатися. \nЯ вірю в це.',
    translation:
        'If I could, I would go to Iceland. \nI dream of seeing the northern lights. \nI also want to swim in a hot spring. \nIf I had more money, I would travel more. \nI would learn new languages. \nI would open a small café. \nI would live near the sea. \nDreams make life more interesting. \nEverything is possible if you try. \nI believe in that.'
},

    // LESSON 21
    // Books & Reading

    {
  story: 'Я люблю читати книжки. \nЯ читаю щодня перед сном. \nМені подобаються історії про життя людей. \nМоя улюблена книга — «Маленький принц». \nЯ також читаю англійські книги для практики. \nЧитання допомагає мені розслабитись. \nЯ часто беру книги в бібліотеці. \nЧитати — це цікаво і корисно. \nЯ хочу читати ще більше. \nКнижки відкривають новий світ.',
  translation: 'I love reading books. \nI read every night before bed. \nI like stories about people’s lives. \nMy favorite book is “The Little Prince.” \nI also read English books to practice. \nReading helps me relax. \nI often borrow books from the library. \nReading is interesting and useful. \nI want to read even more. \nBooks open a new world.'
},

    // LESSON 22
    // Pets & Animals

    {
  story: 'У мене є кішка. \nЇї звати Міла. \nВона чорна і дуже мила. \nМіла любить спати і гратись. \nЯ годую її кожного дня. \nВона сидить біля мене, коли я читаю. \nЯ дуже люблю тварин. \nВони дарують радість. \nЯ б хотіла мати ще собаку. \nДомашні тварини — це друзі.',
  translation: 'I have a cat. \nHer name is Mila. \nShe is black and very cute. \nMila loves to sleep and play. \nI feed her every day. \nShe sits next to me when I read. \nI love animals very much. \nThey bring joy. \nI would like to have a dog too. \nPets are friends.'
},

    // LESSON 23
    // Environment & Nature

    {
  story: 'Я люблю природу. \nЯ часто гуляю в парку. \nЯ слухаю пташок і дивлюсь на дерева. \nЯ стараюся не смітити. \nЯ використовую екоторбу для покупок. \nЯ сортую сміття вдома. \nМи маємо берегти планету. \nЯ люблю ходити в ліс або на річку. \nПрирода — це спокій. \nМи живемо разом з нею.',
  translation: 'I love nature. \nI often walk in the park. \nI listen to birds and look at the trees. \nI try not to litter. \nI use an eco-bag for shopping. \nI sort my rubbish at home. \nWe must protect the planet. \nI like going to the forest or the river. \nNature is peace. \nWe live with it.'
},

    // LESSON 24
    // Hometown & Neighborhood

    {
  story: 'Я живу в невеликому місті. \nМоє місто спокійне і красиве. \nТут є парк, школа і магазини. \nМені подобається мій район. \nТут живе багато українців. \nЯ знаю своїх сусідів. \nМи вітаємось на вулиці. \nМій будинок біля річки. \nЯ люблю тут жити. \nЦе мій другий дім.',
  translation: 'I live in a small town. \nMy town is quiet and beautiful. \nThere is a park, a school, and shops here. \nI like my neighborhood. \nMany Ukrainians live here. \nI know my neighbors. \nWe say hello in the street. \nMy house is near the river. \nI like living here. \nIt is my second home.'
},

    // LESSON 25
    // Languages & Communication

    {
  story: 'Я говорю українською мовою. \nЗараз я вчу англійську. \nЯ хочу говорити вільно. \nЯ практикую щодня. \nЯ дивлюсь фільми англійською. \nІноді я помиляюсь, але це нормально. \nМови допомагають спілкуватися. \nЯ хочу також вивчити французьку. \nМови відкривають двері у світ. \nЯ люблю вчитися.',
  translation: 'I speak Ukrainian. \nNow I am learning English. \nI want to speak fluently. \nI practice every day. \nI watch movies in English. \nSometimes I make mistakes, but it’s okay. \nLanguages help us communicate. \nI also want to learn French. \nLanguages open doors to the world. \nI love learning.'
},

    // LESSON 26
    // Fashion & Style

    {
  story: 'Я люблю зручний одяг. \nЯ часто ношу джинси і светр. \nМій улюблений колір — синій. \nЯ купую одяг в магазині або онлайн. \nЯ не слідкую за модою. \nАле мені подобається виглядати охайно. \nІноді я вдягаюсь святково. \nЯ люблю вишиванки. \nОдяг показує нашу культуру. \nСтиль — це про себе.',
  translation: 'I like comfortable clothes. \nI often wear jeans and a sweater. \nMy favorite color is blue. \nI buy clothes in a shop or online. \nI don’t follow fashion. \nBut I like to look neat. \nSometimes I dress up for special events. \nI love embroidered shirts. \nClothes show our culture. \nStyle is about yourself.'
},

    // LESSON 27
    // Celebrations & Festivals

    {
  story: 'Я люблю свята. \nМоє улюблене — Різдво. \nМи прикрашаємо дім. \nГотуємо смачні страви. \nЗбираємось з родиною. \nМи співаємо колядки. \nТакож я люблю Великдень. \nМи фарбуємо яйця. \nСвята — це час любові. \nВони дарують радість.',
  translation: 'I love holidays. \nMy favorite is Christmas. \nWe decorate the house. \nWe cook delicious food. \nWe gather with family. \nWe sing carols. \nI also love Easter. \nWe paint eggs. \nHolidays are a time of love. \nThey bring joy.'
},

    // LESSON 28
    // Art & Creativity

    {
  story: 'Я люблю мистецтво. \nМені подобається малювати. \nЯ також люблю дивитись картини. \nЯ ходила в музей у Лондоні. \nТам було багато гарних робіт. \nЯ люблю творити щось руками. \nМистецтво показує емоції. \nКоли я малюю — я щаслива. \nКожна людина може бути творчою. \nЦе надихає.',
  translation: 'I love art. \nI like drawing. \nI also love looking at paintings. \nI went to a museum in London. \nThere were many beautiful works. \nI like making things with my hands. \nArt shows emotions. \nWhen I draw, I feel happy. \nEveryone can be creative. \nIt is inspiring.'
},

    // LESSON 29
    // Transportation & Commuting

    {
  story: 'Я їжджу автобусом на роботу. \nЦе займає 20 хвилин. \nІноді я йду пішки. \nЯ маю карту для транспорту. \nЯ стараюся не запізнюватися. \nУ вихідні я їду в інші міста. \nЯ люблю поїзди. \nВони швидкі та зручні. \nДорожній рух тут спокійний. \nМені подобається подорожувати.',
  translation: 'I take the bus to work. \nIt takes 20 minutes. \nSometimes I walk. \nI have a travel card. \nI try not to be late. \nOn weekends, I go to other towns. \nI like trains. \nThey are fast and comfortable. \nTraffic here is calm. \nI enjoy traveling.'
},

    // LESSON 30
    // Challenges & Achievements

    {
  story: 'Коли я приїхала в Британію, мені було важко. \nЯ не знала мови. \nЯ соромилась говорити. \nАле я почала вчитися. \nЯ ходила на курси. \nЯ знайшла роботу. \nЯ стала впевненішою. \nЦе мій успіх. \nЯ подолала страх. \nЯ пишаюсь собою.',
  translation: 'When I came to Britain, it was hard. \nI didn’t know the language. \nI was shy to speak. \nBut I started to learn. \nI went to classes. \nI found a job. \nI became more confident. \nThis is my achievement. \nI overcame fear. \nI am proud of myself.'
}

]


export const StoriesData = stories.map((value, index) => (
    {
        id: index + 1,
        lesson: index + 1,
        story: value.story,
        translation: value.translation,
        display: "none"
    }
))

